// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardShipmentEventDto
 */
export interface ICardShipmentEventDto {
    /**
     * 
     * @type {Date}
     * @memberof ICardShipmentEventDto
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardShipmentEventDto
     */
    status?: ICardShipmentEventDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardShipmentEventDto
     */
    status_type?: ICardShipmentEventDtoStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardShipmentEventDto
     */
    displayed_status_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICardShipmentEventDtoStatusEnum {
    CREATED_DATE = 'CREATED_DATE',
    PRINT_DATE = 'PRINT_DATE',
    EXPECTED_MAIL_DATE = 'EXPECTED_MAIL_DATE',
    MAILED = 'MAILED',
    EXPECTED_DELIVERY = 'EXPECTED_DELIVERY',
    DELIVERED = 'DELIVERED',
    ACTIVATED = 'ACTIVATED',
    LOST_STOLEN = 'LOST_STOLEN',
    DAMAGED = 'DAMAGED',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
* @export
* @enum {string}
*/
export enum ICardShipmentEventDtoStatusTypeEnum {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    ACTIVE = 'ACTIVE'
}


/**
 * Check if a given object implements the ICardShipmentEventDto interface.
 */
export function instanceOfICardShipmentEventDto(value: object): value is ICardShipmentEventDto {
    return true;
}

export function ICardShipmentEventDtoFromJSON(json: any): ICardShipmentEventDto {
    return ICardShipmentEventDtoFromJSONTyped(json, false);
}

export function ICardShipmentEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardShipmentEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'displayed_status_name': json['displayed_status_name'] == null ? undefined : json['displayed_status_name'],
    };
}

export function ICardShipmentEventDtoToJSON(json: any): ICardShipmentEventDto {
    return ICardShipmentEventDtoToJSONTyped(json, false);
}

export function ICardShipmentEventDtoToJSONTyped(value?: ICardShipmentEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'status': value['status'],
        'status_type': value['status_type'],
        'displayed_status_name': value['displayed_status_name'],
    };
}

